import { MoreHorizontal } from 'lucide-react';
import type { RefObject } from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Switch } from '@/components/ui/switch';
import { downloadPNG, downloadSVG } from '../utils/download';

type DropdownProps = {
  chartRef: RefObject<HTMLDivElement | null>;
  chartTitle: string;
  unit: string;
  exportToExcel?: () => void;
  showAnnotations?: boolean;
  exportDisabled: boolean;
  queryLabel?: string;
  enableAnnotations?: boolean;
  handleShowAnnotations?: () => void;
};

const Dropdown = ({
  chartRef,
  chartTitle,
  unit,
  exportToExcel,
  showAnnotations,
  exportDisabled,
  queryLabel = '',
  enableAnnotations,
  handleShowAnnotations,
}: DropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size={'icon'}
          variant={'ghost'}
          className='rounded-full'
        >
          <MoreHorizontal size={20} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className='p-0'
        align='end'
      >
        <div className='flex flex-col gap-1 px-4 py-5'>
          <div className='flex flex-col'>
            <span className='font-display'>Exportera data</span>
            <span className='text-muted-foreground font-normal'>Tryck på respektive format för att ladda ner.</span>
          </div>
          <div className='mt-3 flex gap-2'>
            {!!exportToExcel && (
              <Button
                variant='secondary'
                className='grow'
                disabled={exportDisabled}
                onClick={() => exportToExcel()}
              >
                Excel
              </Button>
            )}
            <Button
              variant='secondary'
              className='grow'
              disabled={exportDisabled}
              onClick={() => downloadPNG(chartRef, chartTitle, queryLabel, unit)}
            >
              PNG
            </Button>
            <Button
              variant='secondary'
              className='grow'
              disabled={exportDisabled}
              onClick={() => downloadSVG(chartRef, chartTitle, queryLabel, unit)}
            >
              SVG
            </Button>
          </div>
        </div>
        {enableAnnotations && (
          <>
            <DropdownMenuSeparator />
            <div className='relative flex items-center justify-between gap-4 px-4 pt-5 pb-6 focus:bg-none'>
              <div className='flex flex-col'>
                <span className='font-display'>Visa stödlinjer</span>
                <span className='text-muted-foreground font-normal'>Visar högsta, lägsta och medelvärdet.</span>
              </div>
              <Switch
                className='expanded-link mr-1'
                checked={showAnnotations}
                onCheckedChange={handleShowAnnotations}
                size='sm'
              />
            </div>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Dropdown;
